import classNames from 'classnames';
import AnimatedToggle, {
  AnimatedToggleProps,
} from 'components/generics/toggles/AnimatedToggle';
import classes from 'pages/profile/components/ProfileTabContent/Account/InvestmentProfile/components/AccreditedToggle/index.module.scss';
import { useEffect, useState } from 'react';

enum OnOffToggleOptions {
  ON = 'on',
  OFF = 'off',
}

interface Props extends Omit<AnimatedToggleProps, 'items' | 'onChangeValue'> {
  isOn: boolean;
  onChangeValue?: (newValue: boolean) => void;
}

const OnOffToggle = ({ isOn, onChangeValue, ...props }: Props) => {
  const [innerIsOn, setInnerIsOn] = useState(isOn);

  useEffect(() => {
    setInnerIsOn(isOn);
  }, [isOn]);

  const items = [
    { value: OnOffToggleOptions.OFF },
    { value: OnOffToggleOptions.ON },
  ];

  const innerOnChangeValue = () => {
    const toggleValue = !innerIsOn;
    setInnerIsOn(toggleValue);
    onChangeValue && onChangeValue(toggleValue);
  };

  return (
    <AnimatedToggle
      items={items}
      className={classNames(classes.container, innerIsOn && classes.active)}
      itemClassName={classes.item}
      value={innerIsOn ? OnOffToggleOptions.ON : OnOffToggleOptions.OFF}
      onGlobalClick={innerOnChangeValue}
      {...props}
    />
  );
};

export default OnOffToggle;
